import { useTranslation } from 'react-i18next'

import { useContentOverflow } from '../../../../../hooks'
import { DashboardSeverityDot } from '../../../../DashboardBirdview'
import { FloatingTooltip } from '../../../../Floating'
import Text from '../../../../Text'
import {
  OVERVIEW_ATTENTION_TONE_BY_SEVERITY,
  QA_NAME_OVERVIEW_ATTENTION_REASON,
} from '../RentalPortalOverviewAttentionRow.constants'
import { getOverviewAttentionRowReason } from '../RentalPortalOverviewAttentionRow.utils'

import * as styles from './OverviewAttentionReason.module.css'

function OverviewAttentionReason({ row }) {
  const { t } = useTranslation()

  const reason = getOverviewAttentionRowReason({ row, t })

  const { overflow, setContentOverflowRef } = useContentOverflow({
    dep: [reason],
  })

  return (
    <span className={styles.OverviewAttentionReason}>
      <DashboardSeverityDot
        tone={OVERVIEW_ATTENTION_TONE_BY_SEVERITY[row.severity]}
      />
      <FloatingTooltip content={reason} disabled={!overflow}>
        <Text
          isSecondary
          className={styles.reason}
          qaName={QA_NAME_OVERVIEW_ATTENTION_REASON}
          ref={setContentOverflowRef}
        >
          {reason}
        </Text>
      </FloatingTooltip>
    </span>
  )
}

export default OverviewAttentionReason
